import ParameterValue from './parametervalue';
import PricingRule from './pricingrule';

class Contract {
    constructor(json) {
        if (json != null) {
            this.contractNumber = json.contractNumber ? new ParameterValue(json.contractNumber) : null;
            this.invoicingTerms = json.invoicingTerms ? new ParameterValue(json.invoicingTerms) : null;
            this.deliveryTerms = json.deliveryTerms ? new ParameterValue(json.deliveryTerms) : null;

            this.pricingRules = [];
            if (json.pricingRules) {
                for (let r of json.pricingRules) {
                    this.pricingRules.push(new PricingRule(r));
                }
            }
            this.leadOrigin = json.leadOrigin;
            this.annualRebate = json.annualRebate;
            this.tenantCompanyClusterId = json.tenantCompanyClusterId;
        } else {
            this.contractNumber = null;
            this.invoicingTerms = null;
            this.deliveryTerms = null;
            this.pricingRules = [];
            this.leadOrigin = 0;
            this.annualRebate = null;
            this.tenantCompanyClusterId = null;
        }
    }
}

export default Contract;
